import React from 'react';
import styled from 'styled-components';

import Section from './layouts/Section';

import theme from '@theme';

const {
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const ListOfLogosWrapper = styled.ul`
	display: ${({ logoCount }) => (logoCount < 3 ? 'flex' : 'grid')};
	justify-content: center;
	grid-template-columns: repeat(2, 1fr);
	gap: ${({ logoCount }) => (logoCount < 3 ? '5rem' : '1.25rem')};

	${mobileFirstScreenQuery.medium} {
		grid-template-columns: repeat(
			auto-fill,
			minmax(
				calc(
					(100% - (${({ logoCount }) => logoCount} - 1) * 1.25rem) /
						${({ logoCount }) => logoCount}
				),
				1fr
			)
		);
	}

	.logo-line__images {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		box-shadow: ${({ cardStyle }) =>
			cardStyle ? '0px 0px 16px 0px rgba(46, 64, 100, 0.2)' : null};
		padding: ${({ cardStyle }) => (cardStyle ? '20px' : null)};

		img {
			display: block;
			max-width: 100%;
			width: ${({ maxImgWidth }) => maxImgWidth}px;
			height: ${({ maxImgHeight }) => maxImgHeight}px;
			object-fit: contain;
			padding: ${({ cardStyle }) => (cardStyle ? null : '0 5px')};
		}
	}
`;

const ListOfLogos = ({
	logos,
	maxImgWidth,
	maxImgHeight,
	className,
	cardStyle,
	...props
}) => {
	const imgWidth = maxImgWidth || Math.max(...logos.map(logo => logo?.width));
	const imgHeight =
		maxImgHeight || Math.max(...logos.map(logo => logo?.height));

	return (
		<Section className={className} {...props}>
			{logos && (
				<ListOfLogosWrapper
					logoCount={logos?.length}
					maxImgWidth={imgWidth}
					maxImgHeight={imgHeight}
					cardStyle={cardStyle}
				>
					{logos.map(logo => {
						//see if logos are objects from contentful or urls:
						const logoImg = typeof logo === 'object' ? logo?.file?.url : logo;

						return logoImg ? (
							<li class="logo-line__images" key={logo.contentful_id || logoImg}>
								<img src={logoImg} alt={logo.description || ''} />
							</li>
						) : null;
					})}
				</ListOfLogosWrapper>
			)}
		</Section>
	);
};

export default ListOfLogos;
